import React from 'react'
import styled, { css } from 'styled-components'

import { Drawer } from '@root/shared/ui-kit'

import { ReferralWithdraw } from './common/referral-withdraw'

import type { DrawerControlProps } from '@root/shared/ui-kit'

type Props = DrawerControlProps

export const ReferralWithdrawDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
}) => {
  const handleClose = () => onOpenChange?.(false)

  return (
    <Root open={open} onOpenChange={onOpenChange}>
      <ReferralWithdraw
        device="mobile"
        onClose={handleClose}
        css={css`
          padding-bottom: var(--safe-bottom);
        `}
      />
    </Root>
  )
}

const Root = styled(Drawer)`
  /* height: var(--max-drawer-height); */
`
